<template>
    <div class="deal-page">
        <!-- 顶部搜索区域 -->
        <div class="search-section">
            <div class="search-box">
                <input type="text" v-model="projectName" placeholder="请输入项目名称进行搜索" class="search-input"
                    @keyup.enter="handleSearch" />
                <button class="search-btn" @click="handleSearch">
                    <i class="el-icon-search"></i>
                    搜索
                </button>
            </div>
        </div>

        <!-- 筛选区域 -->
        <section class="filter-section">
            <!-- 采购类型筛选 -->
            <div class="filter-group">
                <div class="filter-label">项目类型</div>
                <div class="filter-options">
                    <div v-for="type in procurementTypes" :key="type.value" class="filter-option"
                        :class="{ active: selectedProcurementType === type.value }"
                        @click="selectProcurementType(type.value)">
                        {{ type.label }}
                    </div>
                </div>
            </div>
            <!-- 公告类型筛选 -->
            <div class="filter-group">
                <div class="filter-label">公告类型</div>
                <div class="filter-options">
                    <div v-for="type in announcementTypes" :key="type.value" class="filter-option"
                        :class="{ active: selectedAnnouncementType === type.value }"
                        @click="selectAnnouncementType(type.value)">
                        {{ type.label }}
                    </div>
                </div>
            </div>
            <!-- 项目地区筛选 -->
            <div class="filter-group">
                <div class="filter-label">项目地区</div>
                <div class="filter-options">
                    <div v-for="region in visibleRegions" :key="region.value" class="filter-option"
                        :class="{ active: selectedRegion === region.value }" @click="selectRegion(region)">
                        {{ region.label }}
                    </div>
                    <div class="filter-option expand-btn" @click="toggleRegionExpand">
                        {{ isRegionExpanded ? '收起' : '展开' }}
                        <i :class="isRegionExpanded ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
                    </div>
                </div>
            </div>
        </section>

        <!-- 公告列表 -->
        <div class="announcement-table">
            <header class="table-header">
                <div class="header-cell announcement-name-header">公告名称</div>
                  <div class="header-cell release-time-header">公告性质</div>
                <div class="header-cell release-time-header">发布时间</div>
            </header>
            <div class="table-body" v-if="announcements.length != 0">
                <div v-for="(item, index) in announcements" :key="`announcement-${index}`" class="table-row"
                    @click="goDetail(item)">
                    <div class="cell announcement-name">
                        <span class="region-info">{{ item.projectLocationProvince }}</span>
                        
                        <span class="announcement-title">{{ item.noticeName }}</span>
                    </div>
                    
                       <div class="cell release-time"  :class="item.noticeNature === 2 ? 'nature-change' : 'nature-normal' " style="height: 10px; width: 80px;  margin-top: 10px;">{{ item.noticeNature === 2 ? '变更公告' : '正常公告' }}</div>
                    <div class="cell release-time">{{ extractDateFromString(item.noticeSendTime) }}</div>
                </div>
            </div>
            <div v-else class="empty-data">
                <el-empty description="暂无数据"></el-empty>
            </div>

            <!-- 分页 -->
            <div class="pagination-wrapper">
                <el-pagination background layout="prev, pager, next, sizes, total" :total="total" :page-size="pageSize"
                    :current-page="pageIndex" :page-sizes="[10, 20, 50, 100]" @current-change="handlePageChange"
                    @size-change="handleSizeChange">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import areaData from 'china-area-data'
import { getNoticeList } from '@/api/modules/home'

const PROCUREMENT_TYPES = [
    { value: '1', label: '企业采购' },
    { value: '2', label: '政府采购' },
    { value: '3', label: '建设工程' }
];

const ANNOUNCEMENT_TYPES = [
    { value: '1', label: '招标公告' },
    { value: '2', label: '中标公告' },
    { value: '3', label: '中标候选人公示' },
    { value: '4', label: '澄清公告' },
];

export default {
    name: 'DealPage',
    data() {
        return {
            areaData: areaData,
            projectName: '',
            announcements: [],
            total: 0,
            pageIndex: 1,
            pageSize: 10,
            isRegionExpanded: false,
            selectedRegion: '',
            selectedProcurementType: '1',
            selectedAnnouncementType: '1',
            procurementTypes: PROCUREMENT_TYPES,
            announcementTypes: ANNOUNCEMENT_TYPES,
            allRegions: []
        }
    },
    computed: {
        visibleRegions() {
            return this.isRegionExpanded ? this.allRegions : this.allRegions.slice(0, 15);
        },


        channelCode() {
            return this.$channelMaterial.getChannelCode()
        },
    },
    mounted() {
        this.initAreaData();
        this.getNoticeList();
        
        
    },
    methods: {
        initAreaData() {
            try {
                const provinces = this.areaData['86'];
                const arr = Object.keys(provinces).map(code => ({
                    label: provinces[code],
                    value: code
                }));
                this.allRegions = [{ label: '全部', value: '' }, ...arr];
            } catch (error) {
                console.error('初始化地区数据失败:', error);
            }
        },
        handleSearch() {
            this.pageIndex = 1;
            this.getNoticeList();
        },
        selectProcurementType(value) {
            this.selectedProcurementType = value;
            this.pageIndex = 1;
            this.getNoticeList();
        },
        selectAnnouncementType(value) {
            this.selectedAnnouncementType = value;
            this.pageIndex = 1;
            this.getNoticeList();
        },
        selectRegion(region) {
            this.selectedRegion = region.value;
            this.pageIndex = 1;
            this.getNoticeList();
        },
        toggleRegionExpand() {
            this.isRegionExpanded = !this.isRegionExpanded;
        },
        handlePageChange(page) {
            this.pageIndex = page;
            this.getNoticeList();
        },
        handleSizeChange(size) {
            this.pageSize = size;
            this.pageIndex = 1;
            this.getNoticeList();
        },
        getNoticeList() {
            this.announcements = []
            let data = {
                pageIndex: this.pageIndex,
                pageSize: this.pageSize,
                procurementType: this.selectedProcurementType,
                provinceCode: this.selectedRegion,
                noticeType: this.selectedAnnouncementType,
                projectName: this.projectName,
                channelCode: this.channelCode,
            }
            getNoticeList(data).then(res => {
                if (res.code === 200) {
                    this.announcements = res.data.records || [];
                    this.total = res.data.total || 0;
                } else {
                    this.$message.error(res.msg)
                }
            })
        },
        goDetail(item) {
            window.open('/homeDetail?noticeCode=' + item.noticeCode + '&noticeType=' + this.selectedAnnouncementType, '_blank')
        },
        extractDateFromString(input) {
            if (!input) return '';
            const dateMatch = input.match(/\d{4}-\d{2}-\d{2}/);
            return dateMatch ? dateMatch[0] : '';
        }
    }
}
</script>

<style lang="less" scoped>
.deal-page {
    min-height: 100vh;
    background: #f5f5f5;
    padding: 20px;
    box-sizing: border-box;
}

/* ===== 搜索区域 ===== */
.search-section {
    background: #fff;
    padding: 40px 20px;
    margin-bottom: 20px;
    border-radius: 4px;
}

.search-box {
    max-width: 800px;
    margin: 0 auto;
    display: flex;
    height: 50px;
    border: 1px solid #005EEC;
    border-radius: 4px;
    overflow: hidden;
}

.search-input {
    flex: 1;
    border: none;
    padding: 0 20px;
    font-size: 16px;
    outline: none;

    &::placeholder {
        color: #999;
    }
}

.search-btn {
    width: 120px;
    background: #005EEC;
    color: #fff;
    border: none;
    font-size: 16px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    transition: background 0.3s;

    &:hover {
        background: #0047B8;
    }

    i {
        font-size: 18px;
    }
}

/* ===== 筛选区域 ===== */
.filter-section {
    background: #fff;
    padding: 30px 36px;
    margin-bottom: 20px;
    border-radius: 4px;
}

.filter-group {
    margin-bottom: 16px;
    display: flex;
    align-items: flex-start;
    gap: 16px;

    &:last-child {
        margin-bottom: 0;
    }
}

.filter-label {
    font-size: 14px;
    color: #656668;
    white-space: nowrap;
    width: 70px;
    padding-top: 6px;
    flex-shrink: 0;
}

.filter-options {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    flex: 1;
}

.filter-option {
    padding: 6px 16px;
    border: 1px solid transparent;
    border-radius: 4px;
    font-size: 14px;
    font-family: PingFang SC, PingFang SC;
    color: #333;
    cursor: pointer;
    background: #fff;
    transition: all 0.2s;

    &:hover {
        border-color: #005EEC;
        color: #005EEC;
    }

    &.active {
        border-color: #005EEC;
        color: #005EEC;
        background: rgba(0, 94, 236, 0.05);
    }
}

.expand-btn {
    display: flex;
    align-items: center;
    gap: 4px;
    color: #656668;

    i {
        font-size: 12px;
        transition: transform 0.3s;
    }
}

/* ===== 公告列表 ===== */
.announcement-table {
    background: #fff;
    border-radius: 4px;
    overflow: hidden;
}

.table-header {
    display: flex;
    text-align: start;
    gap: 10px;
    padding: 0 20px;
    background: #F7F8FA;
}

.header-cell {
    font-size: 14px;
    height: 50px;
    line-height: 50px;
    color: #656668;
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
}

.announcement-name-header {
    flex: 1;
    padding-left: 10px;
}

.release-time-header {
    width: 120px;
    text-align: center;
}

.table-body {
    max-height: 600px;
    overflow-y: auto;
}

.table-row {
    display: flex;
    text-align: start;
    gap: 10px;
    padding: 0 20px;
    border-bottom: 1px solid #f0f0f0;
    transition: background 0.2s;

    &:hover {
        background: #fafafa;
    }
}

.cell {
    padding: 16px 10px;
    font-size: 14px;
    color: #333;
    display: flex;
    align-items: center;
}

.announcement-name {
    flex: 1;
    text-align: start;
    line-height: 1.5;
    cursor: pointer;

    &:hover .announcement-title {
        color: #005EEC;
    }
}

.region-info {
    width: 100px;
    min-width: 100px;
    color: #005EEC;
    margin-right: 12px;
    display: inline-block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 13px;
}

.announcement-title {
    flex: 1;
    color: #272829;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    transition: color 0.2s;
}

.release-time {
    width: 120px;
    color: #666;
    font-size: 14px;
    text-align: center;
    justify-content: center;
}

.empty-data {
    padding: 60px 0;
    text-align: center;
}

/* ===== 分页 ===== */
.pagination-wrapper {
    padding: 20px;
    display: flex;
    justify-content: center;
    border-top: 1px solid #f0f0f0;
}

.nature-normal {
  color: #00A26C;
  background: rgba(0, 162, 108, 0.1);
}

.nature-change {
  color: #E6A23C;
  background: rgba(230, 162, 60, 0.1);
}
</style>